import React from "react"
import PropTypes from "prop-types"
import { Button, Flex } from "antd"
import { useTranslation } from "react-i18next"
import basketImage from "assets/imagesV2/empty-cart-basket.svg"
import handleImage from "assets/imagesV2/empty-cart-handle.svg"
import styles from "./WidgetCart.module.css"

// The design's empty-cart illustration is two layers placed in a 100px box.
const EmptyCart = ({ onChooseExperience }) => {
  const { t } = useTranslation()
  return (
    <Flex vertical align="center" justify="center" gap={24} className={styles.empty}>
      <div className={styles.illustration}>
        <div className={styles.illustrationBox}>
          <img src={basketImage} alt="" width="63.1" height="85.8667" className={styles.illustrationBasket} />
          <img src={handleImage} alt="" width="35.5333" height="89.9" className={styles.illustrationHandle} />
        </div>
      </div>
      <Flex vertical align="center" gap={4}>
        <span className={styles.emptyTitle}>{t("booking_widget.cart.empty_title")}</span>
        <span className={styles.emptyText}>{t("booking_widget.cart.empty_text")}</span>
      </Flex>
      <Button type="primary" shape="round" size="large" onClick={onChooseExperience}>
        {t("booking_widget.cart.choose_experience")}
      </Button>
    </Flex>
  )
}

EmptyCart.propTypes = {
  onChooseExperience: PropTypes.func.isRequired
}

export default EmptyCart
